"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MtaDeclineTextOnLimitExceededWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var react_router_dom_1 = require("react-router-dom");
var journey_model_1 = require("@athena-portal/journey-model");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var MtaDeclineTextOnLimitExceededWidget = /** @class */ (function (_super) {
    __extends(MtaDeclineTextOnLimitExceededWidget, _super);
    function MtaDeclineTextOnLimitExceededWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.stopRenewal = _this.stopRenewal.bind(_this);
        _this.state = {
            renewalProposal: undefined,
        };
        _this.isRenewal = _this.getSetting("isRenewal", false);
        return _this;
    }
    MtaDeclineTextOnLimitExceededWidget.prototype.componentDidMount = function () {
        var _this = this;
        if (this.isRenewal) {
            this.customerPortalService.getRenewalProposal(this.props.interaction.agreementNumber).subscribe(function (renewalProposal) {
                _this.setState({
                    renewalProposal: renewalProposal,
                });
            });
        }
    };
    MtaDeclineTextOnLimitExceededWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "text-group declineTextWidget", children: [(0, jsx_runtime_1.jsx)("div", { className: "dissatisfied-icon" }), (0, jsx_runtime_1.jsx)("div", { className: "font-weight-bold", children: "With the changes you are looking to make, we\u2019d no longer be able to insure you due to the change in risk." }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("div", { className: "font-weight-semi-bold", children: "You can cancel these changes which will allow the policy to continue, or if the cover is no longer suitable for your needs you can cancel the insurance without a cancellation fee." }), (0, jsx_runtime_1.jsxs)("div", { children: [this.renderCancelChangesButton(), !this.isRenewal && this.renderCancelPolicyButton(), this.isRenewal && this.renderCancelRenewalButton()] })] }));
    };
    MtaDeclineTextOnLimitExceededWidget.prototype.renderCancelPolicyButton = function () {
        return ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/journey/init/product/AnnualHomeInsurance/process/mtcForced/presetPage/".concat(this.props.interaction._id), id: "cancelPolicy", className: "hard-decline", children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary btn-next decline-cancel hard-decline", children: "Cancel policy" }) }));
    };
    MtaDeclineTextOnLimitExceededWidget.prototype.stopRenewal = function () {
        this.props.onStateChange("uistate.mtaDeclineAction", "cancelPolicy");
        this.executeEvent("change");
    };
    MtaDeclineTextOnLimitExceededWidget.prototype.renderCancelRenewalButton = function () {
        return ((0, jsx_runtime_1.jsx)("button", { type: "button", onClick: this.stopRenewal, className: "btn btn-primary btn-next decline-cancel hard-decline", children: "Cancel renewal" }));
    };
    MtaDeclineTextOnLimitExceededWidget.prototype.renderCancelChangesButton = function () {
        return ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/dashboard", id: "decline-page-back", children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-back", children: "Cancel changes" }) }));
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], MtaDeclineTextOnLimitExceededWidget.prototype, "customerPortalService", void 0);
    MtaDeclineTextOnLimitExceededWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "isRenewal", type: journey_model_1.TypeDescriptions.Boolean },
        ]),
        __metadata("design:paramtypes", [Object])
    ], MtaDeclineTextOnLimitExceededWidget);
    return MtaDeclineTextOnLimitExceededWidget;
}(plugin_journey_1.WidgetBase));
exports.MtaDeclineTextOnLimitExceededWidget = MtaDeclineTextOnLimitExceededWidget;
//# sourceMappingURL=MtaDeclineTextOnLimitExceededWidget.js.map